<template>
  <Alert type="warning">
    <template #description>
      You've been invited to a team! Check the invitation
      <InertiaLink href="/team/invitations" class="link">here.</InertiaLink>
    </template>
  </Alert>
</template>

<script setup>
// The Layout shows this bar for a member with an open team invitation.
import Alert from '@/shared/components/Alert.vue'
</script>
